//React
import React, {useEffect} from 'react';
//Компоненты
import Products from "../../../../../components/products";
import Balances from "../../../../../components/balances";
import Button from "../../../../../../../components/button";
//Стили
import "./styles.css";
import "../../../styles.css";
import { Checkbox } from '@mui/material';
import CONFIG from '../../../../../../../../inc/Config';

export default function Balance({
  isAvailable = false,
  selectedSlot,
  productTime,
  balanceProducts,
  countPeople,
  handleProductChange,
  balanceId,
  balances,
  handleBalanceChange,
  handleBookByBalance,
  setAgreement = () => {},
  agreement = false,
  children
}) {
    useEffect(() => {
        if (productTime && !balanceProducts.includes(productTime)) {
            handleProductChange(null);
        }
    }, [])

    const handleButtonClick = () => {
        if(agreement && isAvailable) handleBookByBalance();
    }
    
  return (
    <div className="step-buy__content-body">
      <div className="step-buy__content-row">
        <label className="step-buy__content-row_label">Время (мин)</label>
        <Products
          className="step-buy__content-row_item"
          selectedSlot={selectedSlot}
          selectedProduct={productTime}
          products={balanceProducts}
          countPeople={countPeople}
          onChange={handleProductChange}
          checkMinutes={false}
        />
      </div>
      <div className="step-buy__content-row">
        <label className="step-buy__content-row_label">Депозит</label>
        <Balances
          className="step-buy__content-row_item--last"
          selectedBalanceId={balanceId}
          balances={balances}
          onChange={handleBalanceChange}
        />
      </div>
      {children}
      <div className='step-buy__content-row--agreement'>
        <div  className='agreement_checkbox'>
            <Checkbox
                value={agreement}
                onChange={setAgreement}
                sx={{padding:0}}
            />
        </div>
        <div>Подтверждаю ознакомление с <a target="_blank" href={CONFIG.fileRoutes.privacy}>Политикой конфиденциальности</a> ООО «АЭРОДИНАМИКА» и <a target="_blank" href={CONFIG.fileRoutes.agreement}>Клиентским соглашением</a></div>
      </div>
      <Button className={`${!isAvailable || !agreement ? "step-buy__content-button--disable" : "step-buy__content-button"}`} onClick={handleButtonClick}>
        Оформить
      </Button>
    </div>
  );
};
